import React from 'react'
import Theme from "../../../assets/ui/theme";
import {Flex, Text} from "../../../assets/ui";
import {StyledButton} from "../../../components/common/Button";

const ExperiencedInSales = () => {
    return (
        <Flex padding={["66px 24px", null, "150px 80px 130px"]} flexDirection={"column"} alignItems="center">
            <Text
                fontSize={["24px", null, "32px"]}
                lineHeight={["30px", null, "40px"]}
                color={Theme.colors.darkBlue}
                textAlign="center"
                maxWidth="800px"
                fontWeight="bold"
                marginBottom={["56px"]}>
                Are you experienced in sales? Do you love making money?
                Want to join a of agents who are making the world a better place?
                <Text color={Theme.colors.mainPink}>
                    {" "}Want to make up an extra £70k in your first year, and another £140k in year two?
                </Text>
            </Text>
            <StyledButton>
                Make your move
            </StyledButton>
        </Flex>
    )
};


export default ExperiencedInSales
